import { StarDecorations } from 'components/ui/StarDecorations';
import { DateRangeDisplay } from 'components/ui/DateRangeDisplay';
import { useControlDate } from 'hooks/useControlDate';
import { PHASE_IDS } from 'utils/constants';
import confirmRocket from "assets/img/2026/confirm_rocket.png";
import { useEffect } from 'react';

interface SuccessCardELBBProps {
  onClose: () => void;
  type?: 'ELBB' | 'CONEXAO';
}

export function SuccessCardELBB({ onClose, type = 'ELBB' }: SuccessCardELBBProps) {
  const confirmacaoInscricao = useControlDate(PHASE_IDS.ELBB_CONFIRMATION);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-bb via-blue-bb-1 to-blue-bb-5 overflow-hidden relative flex justify-center pt-16">
      <StarDecorations count={20} density="low" />

      <div className="max-w-4xl w-full mx-6">
        <div className=" rounded-2xl pt-12 shadow-2xl border-4 border-white-bb relative flex">
          {/* Rocket Illustration */}
          <div className="relative inline-block">
            <img src={confirmRocket} alt="Rocket Confirmation" />
          </div>

          <div className="px-8 pb-12 w-full flex flex-col text-4xl">
            {/* Success Message */}
            <h1 className="font-bold text-pink-bb-1">Tudo certo!</h1>

            <div className="text-white-bb rounded-lg mb-8">
              <p className="mb-2 font-bold">
                A <span className="text-green-bb-1">inscrição</span> da sua
                iniciativa no{" "}
                <span className="font-bold text-yellow-bb">
                  {type === 'ELBB' ? 'Prêmio ELBB' : 'Prêmio BB'}
                </span>{" "}
                foi concluída para apreciação do seu gestor
              </p>
              <p className="text-base mt-4 opacity-90 text-white-bb">
                Fique ligado! Durante o período {" "}
                {confirmacaoInscricao ? (
                  <DateRangeDisplay
                    dataInicio={confirmacaoInscricao.dataInicio}
                    dataFim={confirmacaoInscricao.dataFim}
                    dateFormat="dd 'de' MMMM"
                    separator=" A "
                    className="font-bold"
                  />
                ) : (
                  'xx de janeiro'
                )}
                , você poderá acompanhar a apreciação da sua iniciativa.
              </p>
            </div>

            {/* Close Button */}
            <button
              onClick={onClose}
              className="max-w-36 border-white border text-white py-2 rounded-lg text-sm hover:opacity-90 transition-all shadow-lg"
            >
              FECHAR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
